import { numberWithCommas } from '../utils';

export default function countyTemplate(countyInfo) {
  if(!countyInfo) {
    return `No Information`;
  }

  const {
    id,
    county,
    policeForce,
    jurisdiction,
    numberOfPoliceOfficers,
    numberOfDeaths,
    response,
    providedInformation,
    reasonForNoInformation,
    victimName,
    victimImage,
    victimText,
    nextEntry,
    prevEntry
  } = countyInfo;

  return `
    <div class="info">

      <div class="info-section">
        <div class="info-row">
          <div class="info-section__label">County</div>
          <div class="info-section__header">${county}</div>
        </div>
      </div>

      <div class="info-section">
        <div class="info-row">
          <div class="info-section__label">Total Number of Deaths in Police Force Area (2015 - 2017)</div>
          <div class="info-section__header">${response && providedInformation ? numberOfDeaths : 'Unknown'}</div>
        </div>

        ${!response ? `
          <div class="info-row">
            <div class="info-section__body info-section__body--small">
              ${policeForce} did not respond to Broadly's data request within the statutory 20-working day limit mandated by the Freedom of Information Act.
            </div>
          </div>
        ` : ``}

        ${response && !providedInformation && reasonForNoInformation ? `
          <div class="info-row">
            <div class="info-section__body info-section__body--small">
              ${reasonForNoInformation}
            </div>
          </div>
        `:``}
      </div>

      <div class="info-section">
        <div class="info-row">
          <div class="info-section__label">Police Force</div>
          <div class="info-section__header">${policeForce}</div>
        </div>

        <div class="info-row">
          <div class="info-section__label">Number of Police Officers</div>
          <div class="info-section__header">${numberWithCommas(numberOfPoliceOfficers)}</div>
        </div>

        <div class="info-row">
          <div class="info-section__label">Jurisdiction</div>
          <div class="info-section__body">${jurisdiction}</div>
        </div>
      </div>


      ${victimName ? `
        <div class="info-section">
          <div class="info-section__label">One of the Victims</div>
          <div class="info-section__header">${victimName}</div>
          ${victimImage ? `
            <figure class="info-section__image filtered--mono">
              <img src="${victimImage}" alt="image"/>
            </figure>
            ` : ``}
          ${victimText ? `
            <div class="info-section__body">
              ${victimText}
            </div>
            ` : ``}
        </div>
        ` : ``}

      <div class="info-section">
        <div class="info-row clearfix">
          <div class="info-col">
            ${prevEntry ? `
              <div class="info-section__label">Previous</div>
              <div class="info-section__header location-link" data-location-id="${prevEntry.id}">${prevEntry.title}</div>
            ` : ``}
          </div>
          <div class="info-col">
            ${nextEntry ? `
              <div class="info-section__label">Next</div>
              <div class="info-section__header location-link" data-location-id="${nextEntry.id}">${nextEntry.title}</div>
            ` : ``}
          </div>
        </div>
      </div>
    </div>
  `;
}